import { ResearchType } from '@empathy/global/data';

import { IResearchTemplate } from './research-template.interface';

export class SurveyTemplate implements IResearchTemplate {
  id: string;
  activeInd: boolean;
  allowAnonymousInd: boolean;
  allowMultipleInd: boolean;
  category: number;
  description: string;
  lengthOfInterview: number;
  name: string;
  researchType: ResearchType;
  surveyJson: string;
  svgIcon: string;
}
